import { notification } from 'antd';
import { Field } from 'formik';

import { Button, Fields } from 'components';
import { useHooks } from 'hooks';
import Container from 'modules/container';

const Create = ({ createTestimonials, openCreateTestimonials }: any) => {
  const { get, t } = useHooks();

  const data = get(createTestimonials, 'data');

  return (
    <div>
      <Container.Form
        url={data ? `/testimonials/${get(data, '_id')}` : '/testimonials'}
        name="testimonials"
        method={data ? 'put' : 'post'}
        fields={[
          {
            type: 'string',
            name: 'fullName',
            value: get(data, 'fullName'),
            required: true,
          },
          {
            type: 'string',
            name: 'company',
            value: get(data, 'company'),
            required: true,
          }, 
          {
            type: 'string',
            name: 'position',
            value: get(data, 'position'),
            required: true,
          },          
          {
            type: 'any',
            name: 'image',
            value: get(data, 'image'),
            required: true,
          },
          {
            type: 'any',
            name: 'video',
            value: get(data, 'video'),  
            required: true,
          },
        ]}
        onSuccess={(data, resetForm) => {
          openCreateTestimonials({ open: false, data: null });
          resetForm();
        }}
        onError={(error) => {
          notification.error({
            message: get(error, 'errorMessage', t('Something went wrong!')),
            duration: 2,
          });
        }}
      >
        {() => {
          return (
            <div className="mt-[25px]">
              <div className="flex justify-between">
                 <Field
                  type="text"
                  name="fullName"
                  label={t("To'liq ismi")}
                  component={Fields.Input}
                  className="w-[30vw]"
                  placeholder={t("To'liq ismini kiriting")}
                />
                                  </div>
              <div className="flex justify-between">

                <Field
                  type="text"
                  name="company"
                  label={t("Kompaniya")}
                  component={Fields.Input}
                  // className="h-[25vh]"
                  placeholder={t("Kompaniyani kiriting")}
                />
                  {/* </div>
              <div className="flex justify-between"> */}

                <Field
                  type="text"
                  name="position"
                  label={t("Lavozimi")}
                  component={Fields.Input}
                  // className="h-[25vh]"
                  placeholder={t("Lavozimini kiriting")}
                  />
                  </div>
                              <div className="flex justify-evenly mt-[20px]">
                                
                <Field
                  name="image"
                  component={Fields.FileUpload}
                  placeholder={t('Rasm joylash')}
                  className="mb-[10px]"
                  label={t('Video eskiz rasmi')}
                  maxFiles="5"
                />
                <Field
                  name={`video`}
                  component={Fields.FileUpload}
                  placeholder={t('Video joylash')}
                  label={t('Video')}
                  maxSize={1000}
                  isVideo
                  accept=".mp4,.avi,.mov,.flv,.wmv,.webm"
                  className="mb-[10px]"
                  maxFiles="2"
                  rootClassName="mr-[15px]"
                />
              </div>
              <div className="flex mt-[50px] justify-between">
                <Button
                  type="default"
                  title="Bekor qilish"
                  className="w-[48%]"
                  onClick={() => openCreateTestimonials({ open: false, data: null })}
                />
                <Button
                  htmlType="submit"
                  type="primary"
                  title={
                    get(createTestimonials, 'data') ? t('Saqlash') : t('Tasdiqlash')
                  }
                  className="w-[48%]"
                />
              </div>
            </div>
          );
        }}
      </Container.Form>
    </div>
  );
};

export default Create;
